import { createContext, useContext, useState, useEffect } from "react";

// Translations for UI elements
const translations = {
  bm: {
    // Navigation
    home: "Utama",
    events: "Event",
    free: "Percuma",
    calendar: "Kalendar",
    tools: "Alat",
    saved: "Simpanan",
    explore: "Terokai",
    submitEvent: "Hantar Event",
    installApp: "Pasang App",
    
    // Homepage sections
    weekendEvents: "Hujung Minggu Ni",
    nearYou: "Dekat Dengan Anda",
    freeEvents: "Percuma Je",
    thisMonth: "Bulan Ni",
    trending: "Ramai Orang Tengok",
    hiddenGems: "Hidden Gems",
    pickByMood: "Pilih Ikut Mood",
    nextEvent: "Event Seterusnya",
    allEvents: "Semua event",
    allFreeEvents: "Semua free events",
    viewCalendar: "Tengok calendar",
    viewAll: "Semua",
    
    // Event details
    date: "Tarikh",
    location: "Lokasi",
    time: "Masa",
    price: "Harga",
    aboutEvent: "Tentang Event",
    relatedEvents: "Event Berkaitan",
    backToEvents: "Kembali ke Events",
    free: "Percuma",
    
    // Actions
    bookmark: "Simpan",
    share: "Kongsi",
    imGoing: "Saya Pergi",
    addToCalendar: "Tambah ke Calendar",
    copyLink: "Salin Link",
    downloadQR: "Muat Turun QR",
    
    // Calendar
    yearlyCalendar: "Kalendar Tahunan",
    monthlyView: "Paparan Bulanan",
    yearlyView: "Paparan Tahunan",
    publicHolidays: "Cuti Umum",
    schoolHolidays: "Cuti Sekolah",
    longWeekends: "Long Weekend",
    
    // Badges
    today: "Hari Ini",
    tomorrow: "Esok",
    thisWeek: "Minggu Ni",
    daysLeft: "hari lagi",
    new: "Baru",
    popular: "Popular",
    
    // Admin
    adminPanel: "Panel Admin",
    login: "Log Masuk",
    logout: "Log Keluar",
    username: "Nama Pengguna",
    password: "Kata Laluan",
    overview: "Ringkasan",
    pending: "Menunggu",
    approve: "Luluskan",
    reject: "Tolak",
    
    // Categories
    music: "Muzik & Konsert",
    sports: "Sukan & Outdoor",
    cultural: "Budaya & Agama",
    tech: "Teknologi & Perniagaan",
    lifestyle: "Gaya Hidup & Pop Culture",
    underground: "Underground & Local",
    
    // Footer
    madeWith: "Dibuat dengan",
    forMalaysia: "untuk Malaysia",
    quickLinks: "Pautan Pantas",
    followUs: "Ikuti Kami",
    
    // Misc
    loading: "Memuatkan...",
    noEvents: "Tiada event",
    searchPlaceholder: "Cari event...",
    filterByCategory: "Tapis mengikut kategori",
    allCategories: "Semua Kategori",
    eventsFound: "event dijumpai",
    
    // Months
    january: "Januari",
    february: "Februari",
    march: "Mac",
    april: "April",
    may: "Mei",
    june: "Jun",
    july: "Julai",
    august: "Ogos",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Disember",
  },
  en: {
    // Navigation
    home: "Home",
    events: "Events",
    free: "Free",
    calendar: "Calendar",
    tools: "Tools",
    saved: "Saved",
    explore: "Explore",
    submitEvent: "Submit Event",
    installApp: "Install App",
    
    // Homepage sections
    weekendEvents: "This Weekend",
    nearYou: "Near You",
    freeEvents: "Free Events",
    thisMonth: "This Month",
    trending: "Trending Now",
    hiddenGems: "Hidden Gems",
    pickByMood: "Pick By Mood",
    nextEvent: "Next Event",
    allEvents: "All events",
    allFreeEvents: "All free events",
    viewCalendar: "View calendar",
    viewAll: "View all",
    
    // Event details
    date: "Date",
    location: "Location",
    time: "Time",
    price: "Price",
    aboutEvent: "About Event",
    relatedEvents: "Related Events",
    backToEvents: "Back to Events",
    free: "Free",
    
    // Actions
    bookmark: "Save",
    share: "Share",
    imGoing: "I'm Going",
    addToCalendar: "Add to Calendar",
    copyLink: "Copy Link",
    downloadQR: "Download QR",
    
    // Calendar
    yearlyCalendar: "Yearly Calendar",
    monthlyView: "Monthly View",
    yearlyView: "Yearly View",
    publicHolidays: "Public Holidays",
    schoolHolidays: "School Holidays",
    longWeekends: "Long Weekends",
    
    // Badges
    today: "Today",
    tomorrow: "Tomorrow",
    thisWeek: "This Week",
    daysLeft: "days left",
    new: "New",
    popular: "Popular",
    
    // Admin
    adminPanel: "Admin Panel",
    login: "Login",
    logout: "Logout",
    username: "Username",
    password: "Password",
    overview: "Overview",
    pending: "Pending",
    approve: "Approve",
    reject: "Reject",
    
    // Categories
    music: "Music & Concerts",
    sports: "Sports & Outdoor",
    cultural: "Cultural & Religious",
    tech: "Technology & Business",
    lifestyle: "Lifestyle & Pop Culture",
    underground: "Underground & Local",
    
    // Footer
    madeWith: "Made with",
    forMalaysia: "for Malaysia",
    quickLinks: "Quick Links",
    followUs: "Follow Us",
    
    // Misc
    loading: "Loading...",
    noEvents: "No events",
    searchPlaceholder: "Search events...",
    filterByCategory: "Filter by category",
    allCategories: "All Categories",
    eventsFound: "events found",
    
    // Months
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
  },
  zh: {
    // Navigation
    home: "首页",
    events: "活动",
    free: "免费",
    calendar: "日历",
    tools: "工具",
    saved: "收藏",
    explore: "探索",
    submitEvent: "提交活动",
    installApp: "安装应用",
    
    // Homepage sections
    weekendEvents: "本周末",
    nearYou: "附近活动",
    freeEvents: "免费活动",
    thisMonth: "本月",
    trending: "热门活动",
    hiddenGems: "隐藏宝石",
    pickByMood: "按心情选择",
    nextEvent: "下一个活动",
    allEvents: "所有活动",
    allFreeEvents: "所有免费活动",
    viewCalendar: "查看日历",
    viewAll: "查看全部",
    
    // Event details
    date: "日期",
    location: "地点",
    time: "时间",
    price: "价格",
    aboutEvent: "关于活动",
    relatedEvents: "相关活动",
    backToEvents: "返回活动",
    free: "免费",
    
    // Actions
    bookmark: "收藏",
    share: "分享",
    imGoing: "我要去",
    addToCalendar: "添加到日历",
    copyLink: "复制链接",
    downloadQR: "下载二维码",
    
    // Calendar
    yearlyCalendar: "年度日历",
    monthlyView: "月视图",
    yearlyView: "年视图",
    publicHolidays: "公共假期",
    schoolHolidays: "学校假期",
    longWeekends: "长周末",
    
    // Badges
    today: "今天",
    tomorrow: "明天",
    thisWeek: "本周",
    daysLeft: "天后",
    new: "新",
    popular: "热门",
    
    // Admin
    adminPanel: "管理面板",
    login: "登录",
    logout: "退出",
    username: "用户名",
    password: "密码",
    overview: "概览",
    pending: "待审核",
    approve: "批准",
    reject: "拒绝",
    
    // Categories
    music: "音乐与演唱会",
    sports: "体育与户外",
    cultural: "文化与宗教",
    tech: "科技与商业",
    lifestyle: "生活方式与流行文化",
    underground: "地下与本地",
    
    // Footer
    madeWith: "用心制作",
    forMalaysia: "献给马来西亚",
    quickLinks: "快速链接",
    followUs: "关注我们",
    
    // Misc
    loading: "加载中...",
    noEvents: "没有活动",
    searchPlaceholder: "搜索活动...",
    filterByCategory: "按类别筛选",
    allCategories: "所有类别",
    eventsFound: "个活动",
    
    // Months
    january: "一月",
    february: "二月",
    march: "三月",
    april: "四月",
    may: "五月",
    june: "六月",
    july: "七月",
    august: "八月",
    september: "九月",
    october: "十月",
    november: "十一月",
    december: "十二月",
  },
  ta: {
    // Navigation
    home: "முகப்பு",
    events: "நிகழ்வுகள்",
    free: "இலவசம்",
    calendar: "நாட்காட்டி",
    tools: "கருவிகள்",
    saved: "சேமித்தவை",
    explore: "ஆராய்",
    submitEvent: "நிகழ்வு சமர்ப்பி",
    installApp: "ஆப் நிறுவு",
    
    // Homepage sections
    weekendEvents: "இந்த வார இறுதி",
    nearYou: "அருகில்",
    freeEvents: "இலவச நிகழ்வுகள்",
    thisMonth: "இந்த மாதம்",
    trending: "பிரபலமானவை",
    hiddenGems: "மறைந்த ரத்தினங்கள்",
    pickByMood: "மனநிலைப்படி தேர்வு",
    nextEvent: "அடுத்த நிகழ்வு",
    allEvents: "அனைத்து நிகழ்வுகள்",
    allFreeEvents: "அனைத்து இலவச நிகழ்வுகள்",
    viewCalendar: "நாட்காட்டி பார்",
    viewAll: "அனைத்தும் பார்",
    
    // Event details
    date: "தேதி",
    location: "இடம்",
    time: "நேரம்",
    price: "விலை",
    aboutEvent: "நிகழ்வு பற்றி",
    relatedEvents: "தொடர்புடைய நிகழ்வுகள்",
    backToEvents: "நிகழ்வுகளுக்கு திரும்பு",
    free: "இலவசம்",
    
    // Actions
    bookmark: "சேமி",
    share: "பகிர்",
    imGoing: "நான் போகிறேன்",
    addToCalendar: "நாட்காட்டியில் சேர்",
    copyLink: "இணைப்பு நகலெடு",
    downloadQR: "QR பதிவிறக்கு",
    
    // Calendar
    yearlyCalendar: "வருடாந்திர நாட்காட்டி",
    monthlyView: "மாத பார்வை",
    yearlyView: "வருட பார்வை",
    publicHolidays: "பொது விடுமுறைகள்",
    schoolHolidays: "பள்ளி விடுமுறைகள்",
    longWeekends: "நீண்ட வார இறுதிகள்",
    
    // Badges
    today: "இன்று",
    tomorrow: "நாளை",
    thisWeek: "இந்த வாரம்",
    daysLeft: "நாட்கள்",
    new: "புதியது",
    popular: "பிரபலம்",
    
    // Admin
    adminPanel: "நிர்வாக பலகை",
    login: "உள்நுழை",
    logout: "வெளியேறு",
    username: "பயனர்பெயர்",
    password: "கடவுச்சொல்",
    overview: "கண்ணோட்டம்",
    pending: "நிலுவையில்",
    approve: "அங்கீகரி",
    reject: "நிராகரி",
    
    // Categories
    music: "இசை & கச்சேரிகள்",
    sports: "விளையாட்டு & வெளிப்புறம்",
    cultural: "கலாச்சாரம் & மதம்",
    tech: "தொழில்நுட்பம் & வணிகம்",
    lifestyle: "வாழ்க்கை முறை & பாப் கலாச்சாரம்",
    underground: "அண்டர்கிரவுண்ட் & உள்ளூர்",
    
    // Footer
    madeWith: "உருவாக்கப்பட்டது",
    forMalaysia: "மலேசியாவுக்காக",
    quickLinks: "விரைவு இணைப்புகள்",
    followUs: "எங்களை பின்தொடரவும்",
    
    // Misc
    loading: "ஏற்றுகிறது...",
    noEvents: "நிகழ்வுகள் இல்லை",
    searchPlaceholder: "நிகழ்வுகளைத் தேடு...",
    filterByCategory: "வகை மூலம் வடிகட்டு",
    allCategories: "அனைத்து வகைகள்",
    eventsFound: "நிகழ்வுகள் கண்டுபிடிக்கப்பட்டன",
    
    // Months
    january: "ஜனவரி",
    february: "பிப்ரவரி",
    march: "மார்ச்",
    april: "ஏப்ரல்",
    may: "மே",
    june: "ஜூன்",
    july: "ஜூலை",
    august: "ஆகஸ்ட்",
    september: "செப்டம்பர்",
    october: "அக்டோபர்",
    november: "நவம்பர்",
    december: "டிசம்பர்",
  }
};

const languageNames = {
  bm: "Bahasa Melayu",
  en: "English",
  zh: "中文",
  ta: "தமிழ்"
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("upnext_language") || "bm";
  });

  useEffect(() => {
    localStorage.setItem("upnext_language", language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations.bm[key] || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      changeLanguage, 
      t, 
      languages: Object.keys(translations),
      languageNames 
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
}

export default LanguageContext;
